/* eslint-disable quote-props */
/* eslint-disable prettier/prettier */
export const LOAN_DETAILS_CONFIG = {
  'credit card': {
    approve: [
      { label: 'Application', template: 'application' },
      { label: 'Rate', template: 'rate' }
    ],
    approved: [
      { label: 'Application', template: 'application' },
      { label: 'Rate', template: 'rate' }
    ],
    pending: [{ label: 'Application', template: 'application' }],
    'in review': [{ label: 'Application', template: 'application' }],
    refer: [{ label: 'Application', template: 'application' }],
    decline: [{ label: 'Application', template: 'application' }],
    declined: [{ label: 'Application', template: 'application' }],
    withdraw: [
      { label: 'Application', template: 'application' },
      { label: 'Requested Amount', template: 'requestedamount' }
    ],
    default: [{ label: 'Application', template: 'application' }]
  },
  auto: {
    approve: [
      { label: 'Application', template: 'application' },
      { label: 'Rate', template: 'rate' },
      { label: 'Payment', template: 'payment', lineBreak: true }
    ],
    approved: [
      { label: 'Application', template: 'application' },
      { label: 'Rate', template: 'rate' },
      { label: 'Payment', template: 'payment', lineBreak: true }
    ],
    pending: [
      { label: 'Application', template: 'application' },
      { label: 'Requested Amount', template: 'requestedamount' }
    ],
    'in review': [
      { label: 'Application', template: 'application' },
      { label: 'Requested Amount', template: 'requestedamount' }
    ],
    refer: [
      { label: 'Application', template: 'application' },
      { label: 'Requested Amount', template: 'requestedamount' }
    ],
    counter: [
      { label: 'Application', template: 'application' },
      { label: 'Estimated rate', template: 'rate' },
      { label: 'Estimated payment', template: 'payment', lineBreak: true },
      { label: 'Requested Amount', template: 'requestedamount', lineBreak: true }
    ],
    decline: [
      { label: 'Application', template: 'application' },
      { label: 'Requested Amount', template: 'requestedamount' }
    ],
    declined: [
      { label: 'Application', template: 'application' },
      { label: 'Requested Amount', template: 'requestedamount' }
    ],
    withdraw: [
      { label: 'Application', template: 'application' },
      { label: 'Requested Amount', template: 'requestedamount' }
    ],
    default: [{ label: 'Application', template: 'application' }]
  },
  'unsecured loan': {
    approve: [
      { label: 'Application', template: 'application' },
      { label: 'Rate', template: 'rate' },
      { label: 'Payment', template: 'payment', lineBreak: true }
    ],
    approved: [
      { label: 'Application', template: 'application' },
      { label: 'Rate', template: 'rate' },
      { label: 'Payment', template: 'payment', lineBreak: true }
    ],
    pending: [
      { label: 'Application', template: 'application' },
      { label: 'Requested Amount', template: 'requestedamount' }
    ],
    refer: [
      { label: 'Application', template: 'application' },
      { label: 'Requested Amount', template: 'requestedamount' }
    ],
    'in review': [
      { label: 'Application', template: 'application' },
      { label: 'Requested Amount', template: 'requestedamount' }
    ],
    counter: [
      { label: 'Application', template: 'application' },
      { label: 'Estimated rate', template: 'rate' },
      { label: 'Estimated payment', template: 'payment', lineBreak: true },
      { label: 'Requested Amount', template: 'requestedamount', lineBreak: true }
    ],
    decline: [
      { label: 'Application', template: 'application' },
      { label: 'Requested Amount', template: 'requestedamount' }
    ],
    declined: [
      { label: 'Application', template: 'application' },
      { label: 'Requested Amount', template: 'requestedamount' }
    ],
    withdraw: [
      { label: 'Application', template: 'application' },
      { label: 'Requested Amount', template: 'requestedamount' }
    ],
    default: [{ label: 'Application', template: 'application' }]
  },
  'unsecured line of credit': {
    approve: [
      { label: 'Application', template: 'application' },
      { label: 'Rate', template: 'rate' },
      { label: 'Payment', template: 'payment', lineBreak: true }
    ],
    approved: [
      { label: 'Application', template: 'application' },
      { label: 'Rate', template: 'rate' },
      { label: 'Payment', template: 'payment', lineBreak: true }
    ],
    pending: [
      { label: 'Application', template: 'application' },
      { label: 'Requested Amount', template: 'requestedamount' }
    ],
    refer: [
      { label: 'Application', template: 'application' },
      { label: 'Requested Amount', template: 'requestedamount' }
    ],
    'in review': [
      { label: 'Application', template: 'application' },
      { label: 'Requested Amount', template: 'requestedamount' }
    ],
    decline: [
      { label: 'Application', template: 'application' },
      { label: 'Requested Amount', template: 'requestedamount' }
    ],
    declined: [
      { label: 'Application', template: 'application' },
      { label: 'Requested Amount', template: 'requestedamount' }
    ],
    withdraw: [
      { label: 'Application', template: 'application' },
      { label: 'Requested Amount', template: 'requestedamount' }
    ],
    default: [{ label: 'Application', template: 'application' }]
  },
  'home equity line of credit': {
    approve: [
      { label: 'Application', template: 'application' },
      { label: 'Rate', template: 'rate' },
      { label: 'Payment', template: 'payment', lineBreak: true }
    ],
    approved: [
      { label: 'Application', template: 'application' },
      { label: 'Rate', template: 'rate' },
      { label: 'Payment', template: 'payment', lineBreak: true }
    ],
    pending: [
      { label: 'Application', template: 'application' },
      { label: 'Requested Amount', template: 'requestedamount' }
    ],
    'in review': [
      { label: 'Application', template: 'application' },
      { label: 'Requested Amount', template: 'requestedamount' }
    ],
    refer: [
      { label: 'Application', template: 'application' },
      { label: 'Requested Amount', template: 'requestedamount' }
    ],
    counter: [
      { label: 'Application', template: 'application' },
      { label: 'Estimated rate', template: 'rate' },
      { label: 'Estimated payment', template: 'payment', lineBreak: true },
      { label: 'Requested Amount', template: 'requestedamount', lineBreak: true }
    ],
    declined: [
      { label: 'Application', template: 'application' },
      { label: 'Requested Amount', template: 'requestedamount' }
    ],
    decline: [
      { label: 'Application', template: 'application' },
      { label: 'Requested Amount', template: 'requestedamount' }
    ],
    withdraw: [
      { label: 'Application', template: 'application' },
      { label: 'Requested Amount', template: 'requestedamount' }
    ],
    default: [{ label: 'Application', template: 'application' }]
  },
  default: {
    approve: [
      { label: 'Application', template: 'application' },
      { label: 'Rate', template: 'rate' },
      { label: 'Payment', template: 'payment', lineBreak: true }
    ],
    approved: [
      { label: 'Application', template: 'application' },
      { label: 'Rate', template: 'rate' },
      { label: 'Payment', template: 'payment', lineBreak: true }
    ],
    pending: [
      { label: 'Application', template: 'application' },
      { label: 'Requested Amount', template: 'requestedamount' }
    ],
    'in review': [
      { label: 'Application', template: 'application' },
      { label: 'Requested Amount', template: 'requestedamount' }
    ],
    refer: [
      { label: 'Application', template: 'application' },
      { label: 'Requested Amount', template: 'requestedamount' }
    ],
    counter: [
      { label: 'Application', template: 'application' },
      { label: 'Estimated rate', template: 'rate' },
      { label: 'Estimated payment', template: 'payment', lineBreak: true },
      { label: 'Requested Amount', template: 'requestedamount', lineBreak: true }
    ],
    declined: [
      { label: 'Application', template: 'application' },
      { label: 'Requested Amount', template: 'requestedamount' }
    ],
    decline: [
      { label: 'Application', template: 'application' },
      { label: 'Requested Amount', template: 'requestedamount' }
    ],
    withdraw: [
      { label: 'Application', template: 'application' },
      { label: 'Requested Amount', template: 'requestedamount' }
    ],
    default: [{ label: 'Application', template: 'application' }]
  }
};
